import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import VisualStorytellingIdentity from "./sections/VisualStorytellingIdentity";
import EliteCategories from "./sections/EliteCategories";
import TheGreenFootprint from "./sections/TheGreenFootprint";
import SustainableBestSellers from "./sections/SustainableBestSellers";
import JoinTheSquad from "./sections/JoinTheSquad";
import EcoThreadCommunityFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <VisualStorytellingIdentity />
      <EliteCategories />
      <TheGreenFootprint />
      <SustainableBestSellers />
      <JoinTheSquad />
      <EcoThreadCommunityFooter />
    </div>;
}